import axios from 'axios';
import {
  GET_BANK_ACCOUNTS_REQUEST,
  GET_BANK_ACCOUNTS_SUCCESS,
  GET_BANK_ACCOUNTS_FAILURE,
  DELETE_BANK_ACCOUNT_SUCCESS,
  DELETE_BANK_ACCOUNT_FAILURE
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getBankAccounts = isFull => async dispatch => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({
        type: GET_BANK_ACCOUNTS_REQUEST
      });

      let path = `${API_GATEWAY}/bank-accounts/v2?`;

      let params = {};

      if (isFull) {
        params.isFull = true;
      }

      params = new URLSearchParams(params);

      const res = await axios.get(path + params.toString());

      dispatch({
        type: GET_BANK_ACCOUNTS_SUCCESS,
        payload: res.data.content
      });

      resolve(res.data.content);
      return res.data.content;

    } catch (e) {

      dispatch({
        type: GET_BANK_ACCOUNTS_FAILURE,
        payload: 'Not Fetched'
      });

      reject(e);
    }
  });
};

export const deleteBankAccount = payload => async dispatch => {
  try {
    await axios.delete(`${API_GATEWAY}/bank-accounts`, {
      data: {
        ...payload
      }
    });

    dispatch({
      type: DELETE_BANK_ACCOUNT_SUCCESS,
      payload,
    });

    return { success: true };
  } catch (e) {
    dispatch({
      type: DELETE_BANK_ACCOUNT_FAILURE,
      payload: 'Hesap silinemedi.'
    });

    return {
      success: false,
      error: {
        code: e?.response?.data?.code,
        message: e?.response?.data?.message
      }
    };
  }
};
